import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["minInput", "maxInput"]

  validate(event) {
    const minRaw = this.minInputTarget.value
    const maxRaw = this.maxInputTarget.value

    if (minRaw === "" || maxRaw === "") return

    const minVal = parseInt(minRaw)
    const maxVal = parseInt(maxRaw)

    if (isNaN(minVal) || isNaN(maxVal) || minVal <= maxVal) return

    if (event.target === this.minInputTarget) {
      this.#setValue(this.maxInputTarget, minRaw)
    } else {
      this.#setValue(this.minInputTarget, maxRaw)
    }
  }

  #setValue(el, value) {
    const ts = el.tomselect
    if (ts) {
      ts.setValue(value, true)
    } else {
      el.value = value
    }
  }
}
